import styled from '@emotion/styled'
import { ButtonWithIcon } from 'src/components/button/button-with-icon'
import { Shapes } from 'src/components/theme'

const ActionButton = styled(ButtonWithIcon)`
  border: none;
  align-self: center;
  padding: ${Shapes.spacing[1]}px ${Shapes.spacing[2]}px;
`

const ActionButtonV2 = styled(ButtonWithIcon)`
  border: none;
  align-self: center;
  padding: 0 12px;
  height: 100%;
  border-radius: 0;
  border-top-right-radius: ${Shapes.borderRadius}px;
  border-bottom-right-radius: ${Shapes.borderRadius}px;
`

export type SearchActionProps = {
  icon?: React.ReactNode
  name: string
  onClick: React.MouseEventHandler<HTMLButtonElement> | undefined
  disabled?: boolean
  color?: string
}
export const SearchAction = (props: SearchActionProps) => {
  const { name, onClick, disabled, color } = props
  return (
    <ActionButton inverted disabled={disabled} onClick={onClick} color={color}>
      {name}
    </ActionButton>
  )
}

// TODO: pretty sure we are going to use this new design in map explorer as well, so once is implemented there, we can remove the old one
export const SearchActionV2 = (props: SearchActionProps) => {
  const { name, onClick, disabled, color, icon } = props
  return (
    <ActionButtonV2 inverted disabled={disabled} onClick={onClick} color={color}>
      {icon}
      {name}
    </ActionButtonV2>
  )
}
